// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"226":"2eda0c5d","407":"e164c01e"}[chunkId] + ".chunk.css";
};